export async function fetchWeb3Projects() {
  const response = await fetch("/web3_projects.json");
  return await response.json();
}
